/**
 * Класс для управления динамическими полями в приложении
 * @package DynamicFieldClass
 * @version 1.0
 * @author BOLOTOV I.P.
 * @since 17.08.2022
 * @copyright (c) Internet-Frigate {@link http://www.ifrigate.ru}
 */
import {IDynamicField} from '../interfaces/DynamicField.interface';
import {Validators} from '@angular/forms';
import {AfterViewInit, Injectable, OnInit} from '@angular/core';
import {DynamicFieldService} from './DynamicFieldService.service';
@Injectable()
/** Класс для управления динамическими полями */
export abstract class DynamicFieldClass implements IDynamicField, AfterViewInit, OnInit {
    /** Constructor */
    protected constructor(public service: DynamicFieldService) {
    }

    /**
     * Блокировка поля
     * @param disabled значение флага
     */
    setDisabled(disabled): void {
        this.service.field.disabled = disabled;
        if (this.service.field.disabled) {
            this.service.group.get(this.service.field.name).disable({onlySelf: true, emitEvent: false});
        } else {
            this.service.group.get(this.service.field.name).enable({onlySelf: true, emitEvent: false});
        }
    }

    /** Вызывается фреймворком Angular после инициализации представления компонента */
    ngAfterViewInit(): void {
        const validators = [];
        if (this.service.field.required) {
            validators.push(Validators.required);
        }
        if (validators.length) {
            setTimeout(() => {
                this.service.group.get(this.service.field.name).addValidators(validators);
                this.service.group.get(this.service.field.name).updateValueAndValidity({
                    emitEvent: false
                });
            });
        }
    }

    /** Вызывается один раз после установки свойств компонента */
    ngOnInit(): void {
    }
}
